// Whether the path panel beside the chat was left open, per browser
// (decision 7). A convenience only: storage can be unavailable (a private
// window, blocked site data) and every read or write may throw, so both are
// wrapped and a failure falls back to the default. Opening a path always
// opens its panel, whatever is stored here.

const KEY = 'paths-panel-open';

export function readPanelOpen(fallback = true) {
  try {
    const value = window.localStorage.getItem(KEY);
    if (value === 'true') return true;
    if (value === 'false') return false;
    return fallback;
  } catch {
    return fallback;
  }
}

export function writePanelOpen(open) {
  try {
    window.localStorage.setItem(KEY, open ? 'true' : 'false');
  } catch {
    // Storage unavailable: the panel still works, it just is not remembered.
  }
}
